import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

import {
  InvitationContent,
  useFetchInvitation,
  useInvitation,
  useInvitationActions,
  useInvitationMutations,
} from '@/modules/account'
import { authLoaders, useUser } from '@/modules/auth'

export const Route = createFileRoute('/invitations/$token')({
  staticData: { title: 'Invitation' },
  beforeLoad: async () => {
    await authLoaders().getSession()
  },
  component: InvitationPage,
})

function InvitationPage() {
  const { token } = Route.useParams()
  const { acceptInvitation } = useInvitationMutations()
  const { setKind } = useInvitationActions()
  const { kind } = useInvitation()
  const user = useUser()

  useFetchInvitation(token)

  useEffect(() => {
    const isNotReadyToAccept = !['loaded', 'prompt_login'].includes(kind)
    if (isNotReadyToAccept) return

    if (!user) {
      setKind('prompt_login')
      return
    }

    if (user) {
      acceptInvitation(token)
    }
  }, [user, kind])

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="w-full max-w-md">
        <InvitationContent token={token} />
      </div>
    </div>
  )
}
